import { get } from 'lodash';

const PdpConfig = class {
  static get _config() {
    return get(window, ['ALLBIRDS', 'pdpData']);
  }

  static get id() {
    return get(PdpConfig.product, 'id');
  }

  static get description() {
    return get(PdpConfig.product, 'description');
  }

  static get featuredImage() {
    return get(PdpConfig.product, 'featuredImage');
  }

  static get featuredImageSrc() {
    return get(PdpConfig.featuredImage, 'src');
  }

  static get formattedPrice() {
    return Number((get(PdpConfig.product, 'price') / 100).toFixed(2));
  }

  static get fullName() {
    return get(PdpConfig.product, 'fullName');
  }

  static get handle() {
    return get(PdpConfig.product, 'handle');
  }

  static get gender() {
    return get(PdpConfig.product, 'gender');
  }

  static get masterName() {
    return get(PdpConfig.product, 'masterName');
  }

  static get price() {
    return get(PdpConfig.product, 'price');
  }

  static get product() {
    return get(PdpConfig._config, 'product');
  }

  static get reviewsProductId() {
    return get(PdpConfig._config, 'reviewsProductId');
  }

  static get reviewsProductUrl() {
    return get(PdpConfig._config, 'reviewsProductUrl');
  }

  static get reviewsRatingValue() {
    return get(PdpConfig._config, 'reviewsRatingValue');
  }

  static get type() {
    return get(PdpConfig.product, 'type');
  }
};

export default PdpConfig;
